import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, errorMessage: error.message };
    }
    componentDidCatch(error, info) {
        this.setState({ hasError: true });
    }

    render() {
        const { hasError, errorMessage } = this.state;
        const { children } = this.props;

        return hasError ? (
            <div>Something went wrong! {errorMessage}</div>
        ) : (
            children
        );
    }
}
